import { z } from 'zod';
import { MessageReactions } from '../index.types';

/**
 * Zod schema for IMessageReactions
 * Validates an object with emoji keys and arrays of string personIds as values
 */
const messageReactionsObjectSchema = z.record(
  z.string(),
  z.array(z.string())
);

/**
 * Type guard to check if value is a valid IMessageReactions object
 */
export function isReactionsObject(
  value: any
): value is MessageReactions {
  const result = messageReactionsObjectSchema.safeParse(value);
  return result.success;
}